import { Route, Routes } from 'react-router-dom';
import { ProductListRoute } from './product-list';
import { ProductRoute } from './product';
import { ProductCreateRoute } from './product-create';
import { ProductDetailsTab } from './product/tabs/product-details.tab';
import { ProductAgreementsTab } from './product/tabs/product-agreements.tab';
import { mapObject } from '@client/toolkit';

export const ProductsPaths = {
  Products: '/products',
  ProductCreate: '/products/create',
  Product: '/products/details/:id',
  ProductAgreements: '/products/details/:id/agreements',
};

const RouterPaths = mapObject(ProductsPaths, (val: string) => val.replace(ProductsPaths.Products, ''));

export const ProductsRouter = () => (
  <Routes>
    <Route path="/" element={<ProductListRoute />}>
      <Route path={RouterPaths.ProductCreate} element={<ProductCreateRoute />} />
    </Route>
    <Route path={RouterPaths.Product} element={<ProductRoute />}>
      <Route index element={<ProductDetailsTab />} />
      <Route path="agreements" element={<ProductAgreementsTab />} />
    </Route>
  </Routes>
);
